import { apiFetch } from "./client";
import type { VoceMenu } from "@/types";

// Risposte di backend/app/voci_menu/admin_router.py.
export interface VociMenuAgenzia {
  account_id: string;
  nome: string | null;
  voci: Record<VoceMenu, boolean>;
}

const BASE = "/admin/voci-menu";

export const vociMenuApi = {
  lista: () => apiFetch<{ agenzie: VociMenuAgenzia[] }>(BASE),
  imposta: (accountId: string, voce: VoceMenu, acceso: boolean) =>
    apiFetch<{ account_id: string; voce: VoceMenu; acceso: boolean }>(
      `${BASE}/${encodeURIComponent(accountId)}/${voce}`,
      { method: "PUT", body: JSON.stringify({ acceso }) },
    ),
};
